import './text-image.scss'

class Popup {
  elements
  constructor(selector) {
    this.elements = document.querySelectorAll(selector)
    Array.from(this.elements).map(el => this.init(el))
  }

  init(el) {
    const closeButtons = el.querySelectorAll('[data-popup-close]');

    Array.from(closeButtons).map(btn => btn.addEventListener('click', () => {
      this.close(el);
    }));
  }

  close(el) {
    el.classList.remove('active');
  }
}

new Popup('[data-popup]');
